<template>
  <section v-if="user.information && loaded" >
    <div v-if="!meeting_enabled">

      <div class="center-information">      
        <div class="center-information-content">
        <i class="fa-light fa-2x fa-video-slash"></i>  
        <br /><br />
        {{ $t('NO_MEETING_SERVICE') }}
        </div>
      </div>


    </div>

    <div v-show="message_uuid == ''" v-if="meeting_enabled">
      <b-form inline class="mt-2">
        <AddressBook
        user_uuid=""
        functionbox_uuid=""
        v-slot:activator="{ onClick }"
      >
        <b-button
          @click="onClick"
          class="no-border"
          v-b-tooltip.hover
          :title="$t('ADDRESSBOOK.TITLE')"
        >
          <i class="fal fa-address-book"></i
        ></b-button>
      </AddressBook>

        <b-button @click="refreshList" class="no-border"
          ><i class="fal fa-sync"></i
        ></b-button>
        <AddMeeting :key="addMeetingKey"
          @sentMeeting="sentMeeting"
        ></AddMeeting>

        
          <label class="sr-only" for="search-meetings">{{$t('SEARCH')}}</label>
          <b-form-input trim
            id="search-meetings"
            class="ml-2 i-100 hidden-mobile searchText ml-2"
            v-model="searchText"
            :placeholder="$t('SEARCH')"
            @keydown.enter.prevent
          ></b-form-input>
          <label class="sr-only" for="list-limit-meetings">{{$t('LIMIT')}}</label>
          <b-form-select id="list-limit-meetings" name="meetings_limit"  v-model="limit" class="limit hidden-mobile">
            <b-form-select-option value="10">10</b-form-select-option>
            <b-form-select-option value="25">25</b-form-select-option>
            <b-form-select-option value="45">45</b-form-select-option>
            <b-form-select-option value="100">100</b-form-select-option>
          </b-form-select>
        

          <div class="hidden-not-mobile w-100 mt-2">
            <b-form inline>
              <label class="sr-only" for="search-meetings-mobile">{{$t('SEARCH')}}</label>
              <b-form-input trim
                id="search-meetings-mobile"
                class="ml-2 i-100 searchText"
                v-model="searchText"
                :placeholder="$t('SEARCH')"
                @keydown.enter.prevent
              ></b-form-input>
              <label class="sr-only" for="inline-form-input-limit-mobile">{{$t('LIMIT')}}</label>
              <b-form-select id="inline-form-input-limit-mobile" name="meetings_limit_mobile"  v-model="limit" class="limit">
                <b-form-select-option value="10">10</b-form-select-option>
                <b-form-select-option value="25">25</b-form-select-option>
                <b-form-select-option value="45">45</b-form-select-option>
                <b-form-select-option value="100">100</b-form-select-option>
              </b-form-select>
            </b-form>
          </div>

      </b-form>

      <div :key="listMeetingKey">
        <div v-if="searchText == ''">
          <div class="content-wrapper mt-2">
            <MeetingsCalendar
              @clickedEvent="clickedEvent"
              @changedView="changedView"
              :currentView="currentView"
              :redrawView="listMeetingKey"
            ></MeetingsCalendar>
          </div>
        </div>

        <div v-if="searchText != ''">
          <router-view
            :searchText.sync="searchText"
            @changeUpdateMessageUuid="changeUpdateMessageUuid"
            :update_message_uuid="update_message_uuid"
            @viewingMessage="viewingMessage"
            :limit.sync="limit"
          ></router-view>
        </div>

      </div>

    </div>
    <div v-if="message_uuid != ''">
      <Message
        :message_uuid="message_uuid"
        functionbox_uuid=""
        show-close-btn
        @closeMessage="closeMessage"
      ></Message>
    </div>
  </section>
</template>
<script>
import AddressBook from "@/components/AddressBook/Page";
import MeetingsCalendar from "@/components/Calendar/MeetingsCalendar";
import Message from "@/components/View/Message";
import AddMeeting from "@/components/Compose/AddMeeting";
export default {
  components: { Message, AddMeeting, MeetingsCalendar, AddressBook },
  props: ["functionbox_uuid", "email", "view_message_uuid"],
  data() {
    return {
      currentView: 'Agenda',
      update_message_uuid: "",
      viewMessage: false,
      searchText: "",
      limit: 45,
      information: null,
      message_uuid: this.view_message_uuid,
      keyIndex: 0,
      meeting_enabled: true,
      addMeetingKeyIndex: 0,
      loaded: false,
    };
  },
  methods: {
    async checkEnabled(){
      let self = this;
      await this.$http
        .get(this.user.hostname + "/meeting/enabled")
        .then(function(result) {
          self.meeting_enabled = result.data;
          self.loaded = true;
        })
        .catch(function() {
          self.meeting_enabled = false;
          self.loaded = true;
        });
    },
    changedView(view) {
      this.currentView = view;
    },
    clickedEvent(message_uuid) {
      this.viewingMessage(message_uuid);
    },
    changeUpdateMessageUuid(update_message_uuid) {
      this.update_message_uuid = update_message_uuid;
    },
    refreshList() {
      //console.log("refreshList");
      this.keyIndex++;
    },
    sentMeeting() {
      this.refreshList();
    },
    viewingMessage(message_uuid) {
      this.message_uuid = message_uuid;
      this.update_message_uuid = "";
    },
    closeMessage() {
      this.update_message_uuid = this.message_uuid;
      this.message_uuid = "";
      this.refreshList();
    },
  },
  computed: {
    listMeetingKey() {
      return "listMeetingKey_" + this.keyIndex;
    },
    addMeetingKey(){
      return "addMeetingKey_" + this.keyIndex;
    }
  },
  mounted() {
    this.checkEnabled();
  },
};
</script>
<style></style>
